<template>
  <div>
    <el-timeline-item
      v-if="content"
      :icon="icon"
      :type="type"
      :color="color"
      size="large"
      :timestamp="formatDate(activity.createdOn)"
    >
      <div v-html="formattedActivityText" class=""></div>
    </el-timeline-item>
  </div>
</template>

<script>
import ActivitiesTimelineMixin from "@/components/ActivitiesView/ActivitiesTimelineMixin.vue";
export default {
  mixins: [ActivitiesTimelineMixin],
  props: {
    activity: {
      type: Object,
      required: true
    },
    PLApplication: {
      type: Object,
      required: false
    }
  },
  methods: {
    async generateReadableUpdatePLApplication() {
      let contentHtml = ``;
      for (let update of this.updates) {
        contentHtml = this.generateRegularActivityString(contentHtml, update);
      }
      this.setReadableUpdateProps(contentHtml);
    }
  },
  watch: {
    activity: {
      async handler() {
        this.content = "";
        this.icon = "";
        this.type = "";
        this.link = {};
        this.color = "";
        switch (this.activity.name) {
          case "ADD_PL_APPLICATION_SUCCESS":
            this.generateReadableGeneric({
              content: `added a new Personal liability application for ${this.activity.data?.applicantName}.`,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "ADD_PL_APPLICATION_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to add a personal liability application.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "UPDATE_PL_APPLICATION_SUCCESS":
            await this.generateReadableUpdatePLApplication();
            break;
          case "UPDATE_PL_APPLICATION_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to update a personal liability application.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_PL_APPLICATION_SUCCESS":
            this.generateReadableGeneric({
              content: "deleted a personal liability application.",
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_PL_APPLICATION_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to delete a personal liability application.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
        }
      },
      immediate: true
    }
  }
};
</script>

<style></style>
